/**
 * Apple icon — currentColor so it inherits foreground for dark/light themes.
 * Apple's HIG allows the logo in any color as long as contrast is preserved
 * and proportions are unchanged.
 */
import * as React from 'react';

import { cn } from '../../lib/utils';

interface AppleIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export function AppleIcon({ className, ...props }: AppleIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cn('h-5 w-5', className)}
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
    </svg>
  );
}
